<template>
  <div ref="container" id="container">
    <div v-if="systemVersionTooLow" class="systemVersionTooLow">
      <div class="text">系统版本过低</div>
      <div class="text-other">请换windows10或以上的系统</div>
      <Spin v-if="isLogin" class="openApp_loader" fix>
        <div class="u_loader_k">
          <div class="u_loader"></div>
          <img src="@/assets/images/logo.png" alt />
        </div>
        <div>手相识别中</div>
      </Spin>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    systemVersionTooLow: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
</style>